export default __webpack_public_path__ + "static/media/leaf.16e6d5dc.jpg";